export const GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST =
  'GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST';
export const GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST_SUCCESS =
  'GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST_SUCCESS';
export const GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST_ERROR =
  'GET_COMPONENTS_FOR_DOMAIN_AND_ENTITY_REQUEST_ERROR';
